import React, { SVGAttributes } from 'react';

interface Props extends SVGAttributes<SVGSVGElement> {
  checked: boolean;
}

const CheckmarkIcon = ({ checked, ...svgProps }: Props) => {
  return checked ? (
    <CheckedIcon {...svgProps} />
  ) : (
    <UncheckedIcon {...svgProps} />
  );
};

const UncheckedIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="ic-not_selected"
      data-name="ic-not selected"
      fill="none"
      stroke="#eee"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="12" stroke="none" />
      <circle cx="12" cy="12" r="11" fill="none" />
    </g>
  </svg>
);

const CheckedIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      id="ic-selected"
      d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM9.6,18l-6-6,1.692-1.692L9.6,14.6,18.708,5.5,20.4,7.2Z"
      fill="#9cba6c"
    />
  </svg>
);

export default CheckmarkIcon;
